export default {
  data() {
    return {
    }
  },
  methods: {
    isTableVisible: function(scrollOffsetY, tablePosition){
      return (
        (scrollOffsetY > tablePosition.offsetTop) &&
        scrollOffsetY <= ((tablePosition.offsetTop + tablePosition.clientHeight) - 50)
      );
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/tableCommonMixin.js